import { Button } from "../../components/ui/Button";
import { useAuthStore } from "../../../store/auth/auth.store";

export const Footer: React.FC = () => {
  const { isAuthenticated, isPreAuthenticated, logout } = useAuthStore();

  // Only show footer when user is logged in
  if (!isAuthenticated && !isPreAuthenticated) {
    return null;
  }

  return (
    <footer className="bg-white shadow-sm w-full border-t border-gray-200 mt-auto">
      <div className="mx-auto max-w-7xl px-4 py-4 flex items-center justify-center">
        <Button
          onClick={logout}
          className="w-full sm:w-auto max-w-xs px-4 py-2 text-sm sm:text-base"
        >
          Cerrar sesión
        </Button>
      </div>
    </footer>
  );
};

